import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'empty',
  standalone: false,
})
export class EmptyPipe implements PipeTransform {
  transform(value?: string | null): string {
    return !value ? '-' : value;
  }
}
